import { render, staticRenderFns } from "./FieldIcon.vue?vue&type=template&id=01a8840c&scoped=true"
import script from "./FieldIcon.vue?vue&type=script&lang=js"
export * from "./FieldIcon.vue?vue&type=script&lang=js"
import style0 from "./FieldIcon.vue?vue&type=style&index=0&id=01a8840c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8840c",
  null
  
)

export default component.exports